import { render, staticRenderFns } from "./CompletedCandidateReReview.vue?vue&type=template&id=5871ad2f&scoped=true"
import script from "./CompletedCandidateReReview.vue?vue&type=script&lang=js"
export * from "./CompletedCandidateReReview.vue?vue&type=script&lang=js"
import style0 from "./CompletedCandidateReReview.vue?vue&type=style&index=0&id=5871ad2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871ad2f",
  null
  
)

export default component.exports